module.exports = __webpack_public_path__ + "static/media/horoscope.7c5efb75.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/mobioastro/assets/images/horoscope.jpg
// module id = 996
// module chunks = 0